export default "__VITE_ASSET__DqiyY86g__"